export enum VersionEvent {
  VersionDetected = 'VERSION_DETECTED',
  VersionInstallationFailed = 'VERSION_INSTALLATION_FAILED',
  VersionReady = 'VERSION_READY',
  NoNewVersion = 'NO_NEW_VERSION_DETECTED',
}
